import { CcfBox } from '@nice-ccf/ui-controls';
import CcfExternalDataTabRecords from './ccf-external-data-tab-records';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getAppSpaceRatio } from '../../../global.app.slice';
import CcfExternalDataTabLoyaltyInfo from './ccf-external-data-tab-loyaltyInfo';
import { activeContactSelector } from '../../../ccf-inbox/ccf-inbox.slice';

/* eslint-disable-next-line */
export interface CcfConsumerCardExternalDataTabProps {}

/**@example */
export function CcfConsumerCardExternalDataTab(
  props: CcfConsumerCardExternalDataTabProps
) {
  const [overviewMinValue, setOverviewMinValue] = useState(false);
  const appSpaceRatio = useSelector(getAppSpaceRatio);
  const activeContact = useSelector(activeContactSelector);
  const externalTabDetails: any = activeContact?.externalData;
  const [externalTabData, setExternalTabData] = useState(externalTabDetails);

  useEffect(() => {
    if (
      appSpaceRatio &&
      appSpaceRatio < 63 &&
      activeContact?.media !== 'Voice'
    ) {
      setOverviewMinValue(true);
    } else {
      setOverviewMinValue(false);
    }
  }, [appSpaceRatio]);
  return (
    <CcfBox
      style={{
        display: 'flex',
        width: '100%',
      }}
      sx={
        overviewMinValue
          ? { flexDirection: 'column', maxHeight: '475px', overflowY: 'auto' }
          : { flexDirection: 'row', maxHeight: '510px' }
      }
      id="agent_appSpace_externalData_parentContainer"
    >
      {activeContact?.customer.externalDataLoyaltyInfoHide && (
        <CcfExternalDataTabLoyaltyInfo
          overviewMinValue={overviewMinValue}
          externalTabData={externalTabData}
        />
      )}
      <CcfExternalDataTabRecords
        overviewMinValue={overviewMinValue}
        externalTabData={externalTabData}
      />
    </CcfBox>
  );
}

export default CcfConsumerCardExternalDataTab;
